import styles from "./messages.module.scss"

interface Props {
  tool: string
  phase: "start" | "done"
  error?: string
}

const FRIENDLY_TOOL_LABELS: Record<string, string> = {
  create_applet: "Created Applet",
}

const SUPPRESSED_TOOLS = new Set(["present_applet_success_card"])

export function humanizeToolName(name: string): string {
  if (!name) return ""
  const friendly = FRIENDLY_TOOL_LABELS[name]
  if (friendly) return friendly
  return name
    .replace(/[_-]+/g, " ")
    .toLowerCase()
    .replace(/\bapplet\b/g, "Applet")
    .replace(/^./, c => c.toUpperCase())
}

const ToolIndicator = ({ tool, phase, error }: Props) => {
  const failed = phase === "done" && Boolean(error)
  if (!failed && SUPPRESSED_TOOLS.has(tool)) return null

  const label = humanizeToolName(tool)
  const className = failed ? `${styles["tool-label"]} ${styles["tool-label--error"]}` : styles["tool-label"]

  return (
    <div className={styles["row"]} data-testid="tool-indicator" data-phase={phase}>
      <span className={className}>
        {label}
        {failed ? " (failed)" : ""}
      </span>
    </div>
  )
}

export default ToolIndicator
